import { useEffect, useState } from "react";
import { fileUrl, localPreviews, UploadBar } from "../files";
import { useBoardUI } from "../store";

export function ImageBody({
  id,
  fileId,
  uploading,
  aspect,
  w,
  name,
}: {
  id: string;
  fileId: string | null | undefined;
  uploading?: boolean;
  aspect?: number;
  w: number;
  name?: string;
}) {
  const [src, setSrc] = useState<string | null>(localPreviews.get(id) ?? null);
  const z = useBoardUI((s) => s.camera.z);
  const variant = w * z > 700 ? "large" : "thumb";
  useEffect(() => {
    if (!fileId) return;
    let alive = true;
    fileUrl(fileId, variant)
      .then((u) => alive && setSrc(u))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [fileId, variant]);
  const h = aspect ? Math.round(w / aspect) : 160;
  return (
    <div className="relative overflow-hidden bg-panel-2" style={{ width: "100%", height: h }}>
      {src ? (
        <img
          src={src}
          alt={name ?? ""}
          draggable={false}
          className="block size-full object-cover"
          decoding="async"
        />
      ) : (
        <div className="size-full animate-pulse bg-panel-3" />
      )}
      {uploading ? <UploadBar id={id} label={name} /> : null}
    </div>
  );
}
